import { forwardRef } from 'react';

import { useIntentWithResponse } from '../../../../core/hooks/intent.js';
import {
  type IntentProps,
  type IntentWithResponseProps,
} from '../../../../core/slots/Intent/Intent.js';
import { isIntentWithResponse } from '../../../../core/utils/is-intent-with-response.js';
import {
  getHandleSelect,
  IntentWithoutResponse,
} from '../intent-base/IntentBase.js';
import {
  actionContainer,
  actionText,
} from '../tooltip/ChartTooltip/components/ActionItem/ActionItem.sty.js';
import { TooltipItem } from '../tooltip/section-components/TooltipItem/TooltipItem.js';
import { SymbolAtom } from '../tooltip-atoms/components/SymbolAtom.js';

const IntentWithResponse = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  IntentWithResponseProps
>((props, ref) => {
  const { onSelect, onResponse, payload, options, children, icon } = props;

  const intent = useIntentWithResponse({
    payload,
    options,
  });

  const handleSelect = getHandleSelect(onSelect, intent, onResponse);

  return (
    <TooltipItem className={actionContainer} onClick={handleSelect}>
      {icon ? <SymbolAtom>{icon}</SymbolAtom> : null}
      <div className={actionText}>{children}</div>
    </TooltipItem>
  );
});

export const Intent = forwardRef<HTMLDivElement, IntentProps>((props, ref) => {
  if (isIntentWithResponse(props)) {
    return <IntentWithResponse {...props} ref={ref} />;
  }
  return <IntentWithoutResponse {...props} ref={ref} />;
});
